import { render } from "./ProfileContentLoader.vue?vue&type=template&id=73c5e510"
import script from "./ProfileContentLoader.vue?vue&type=script&lang=js"
export * from "./ProfileContentLoader.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/s.thebuyhive.com/expertsourcing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__